type Props = { name: string; brand?: boolean; className?: string; label?: string };

/** Font Awesome 7 icon. Decorative unless a `label` is given. */
export function Icon({ name, brand, className, label }: Props) {
  return (
    <i
      className={`${brand ? 'fa-brands' : 'fa-solid'} fa-${name}${className ? ` ${className}` : ''}`}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    />
  );
}
